import { useCart } from '@/entities/cart'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'

import { BasketClearButton } from '../basket-clear-button/basket-clear-button'
import { UserTypes } from '../user-types/user-types'

import cl from './top-panel.module.scss'

export const TopPanel = () => {
	const { cartCount, clearCart } = useCart()
	const { isDesktop } = useMediaQueries()

	return (
		<section className={cl.root}>
			<div className={cl.header}>
				<h1 className={cl.title}>Корзина {!!cartCount && <small> — {cartCount}</small>}</h1>
				{!isDesktop && <BasketClearButton onClick={clearCart} />}
			</div>
			<div className={cl.headerWrapper}>
				<div className={cl.types}>
					<UserTypes />
					{isDesktop && <BasketClearButton onClick={clearCart} />}
				</div>
			</div>
		</section>
	)
}
